/* mm-header.js — başlık davranışları: menü (≥1440 üzerine gelince, altında kayan panel), kaydırma, üst şerit mesajları,
   destek balonu, arama (öneri + anlık ürün araması), sepet sayacı ve favoriler. */
(() => {
  if (customElements.get('mm-header')) return;
  const XL = window.matchMedia('(min-width: 1440px)');
  const MD = window.matchMedia('(min-width: 768px)');
  const FAV = 'mm-favoriler';

  const favOku = () => { try { return JSON.parse(localStorage.getItem(FAV) || '[]'); } catch (e) { return []; } };
  const favYaz = (l) => { try { localStorage.setItem(FAV, JSON.stringify(l)); } catch (e) {} document.dispatchEvent(new CustomEvent('mm:favori', { detail: l })); };
  window.mmFavori = {
    liste: favOku,
    var: (h) => favOku().some((x) => x.h === h),
    degistir(urun) {
      const l = favOku(); const i = l.findIndex((x) => x.h === urun.h);
      if (i >= 0) l.splice(i, 1); else l.unshift(urun);
      favYaz(l); return i < 0;
    }
  };

  class MmHeader extends HTMLElement {
    connectedCallback() {
      this.backdrop = document.querySelector('[data-mm-backdrop]');
      if (this.backdrop && this.backdrop.parentElement !== document.body) document.body.appendChild(this.backdrop);
      this.burger = this.querySelector('.mm-burger');
      this.subs = [...this.querySelectorAll('.mm-sub')];
      this.items = [...this.querySelectorAll('.mm-nav__li.has-sub')];
      this.arama = this.querySelector('[data-mm-arama]');
      this.girdi = this.querySelector('[data-mm-arama-girdi]');
      this.esik = parseInt(this.dataset.kaydirEsik || '150', 10);
      this.menuKur(); this.kaydirKur(); this.mesajKur(); this.balonKur(); this.aramaKur(); this.sepetKur(); this.favoriKur();
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.hepsiniKapat(); });
    }

    perde(on) { if (this.backdrop) this.backdrop.classList.toggle('is-on', on); }

    hepsiniKapat() {
      this.altKapat(); this.menuAc(false); this.aramaAc(false);
      this.querySelectorAll('.mm-bubble.is-open, .mm-act.is-open').forEach((n) => n.classList.remove('is-open'));
    }

    /* ----- Menü ----- */
    menuKur() {
      this.burger && this.burger.addEventListener('click', () => this.menuAc(!this.classList.contains('is-menu')));
      this.items.forEach((li) => {
        const a = li.querySelector('.mm-nav__a'); const sub = li.querySelector('.mm-sub');
        let t;
        li.addEventListener('mouseenter', () => { if (!XL.matches) return; clearTimeout(this._kapatT); t = setTimeout(() => this.altAc(li, sub), 80); });
        li.addEventListener('mouseleave', () => { if (!XL.matches) return; clearTimeout(t); this._kapatT = setTimeout(() => this.altKapat(), 120); });
        a.addEventListener('click', (e) => {
          if (XL.matches) return; // ≥1440 link olarak çalışır
          e.preventDefault();
          const acik = sub.classList.contains('is-open');
          this.altKapat(); if (!acik) this.altAc(li, sub);
        });
        a.addEventListener('keydown', (e) => {
          if (!XL.matches) return;
          if (e.key === 'ArrowDown' || (e.key === ' ' && li.classList.contains('has-sub'))) { e.preventDefault(); this.altAc(li, sub); const f = sub.querySelector('a'); f && f.focus(); }
        });
      });
      this.querySelectorAll('[data-mm-geri]').forEach((b) => b.addEventListener('click', () => this.altKapat()));
      XL.addEventListener('change', () => this.hepsiniKapat());
    }
    altAc(li, sub) {
      this.items.forEach((x) => { if (x !== li) { x.classList.remove('is-hover'); x.querySelector('.mm-sub').classList.remove('is-open'); x.querySelector('.mm-nav__a').setAttribute('aria-expanded', 'false'); x.querySelector('.mm-nav__a').classList.remove('is-current'); } });
      if (XL.matches) {
        const ul = this.querySelector('.mm-nav__list').getBoundingClientRect();
        this.style.setProperty('--mm-sub-top', Math.round(ul.bottom) + 'px');
        this.perde(true);
      }
      li.classList.add('is-hover'); sub.classList.add('is-open');
      const a = li.querySelector('.mm-nav__a'); a.setAttribute('aria-expanded', 'true'); a.classList.add('is-current');
    }
    altKapat() {
      this.items.forEach((x) => { x.classList.remove('is-hover'); const s = x.querySelector('.mm-sub'); s && s.classList.remove('is-open'); const a = x.querySelector('.mm-nav__a'); a.setAttribute('aria-expanded', 'false'); a.classList.remove('is-current'); });
      if (XL.matches && !this.arama.classList.contains('is-acik')) this.perde(false);
    }
    menuAc(ac) {
      if (XL.matches) ac = false;
      this.classList.toggle('is-menu', ac);
      this.burger && this.burger.classList.toggle('is-open', ac);
      this.burger && this.burger.setAttribute('aria-expanded', ac ? 'true' : 'false');
      document.body.classList.toggle('mm-lock', ac);
      if (!ac) this.altKapat();
    }

    /* ----- Kaydırma: ≥1440 logo satırı aşağı kaydırmada eşik geçilince kapanır, yukarı kaydırmada açılır.
       Kapanma/açılma başlık yüksekliğini değiştirdiği için tarayıcı kaydırmayı ~73px düzeltir; bu düzeltme yön sayılmaz. ----- */
    kaydirKur() {
      let son = window.scrollY, gizli = false, kilit = 0;
      const ayarla = (g) => { if (g === gizli) return; gizli = g; this.classList.toggle('is-kaydi', g); kilit = performance.now() + 350; };
      const f = () => {
        const y = window.scrollY;
        if (performance.now() < kilit) { son = y; return; }
        if (y > son && y > this.esik) ayarla(true);
        else if (y < son) ayarla(false);
        if (y <= 0) ayarla(false);
        son = y;
      };
      window.addEventListener('scroll', () => requestAnimationFrame(f), { passive: true });
    }

    /* ----- Üst şerit mesajları ----- */
    mesajKur() {
      const m = [...this.querySelectorAll('.mm-topbar__msg')];
      if (m.length < 2) return;
      let i = 0;
      setInterval(() => {
        if (document.hidden) return;
        const a = m[i]; i = (i + 1) % m.length; const b = m[i];
        a.classList.add('is-giden'); b.classList.add('is-gelen');
        setTimeout(() => { a.classList.remove('is-current', 'is-giden'); b.classList.remove('is-gelen'); b.classList.add('is-current'); }, 260);
      }, 5000);
    }

    /* ----- Destek balonu ----- */
    balonKur() {
      this.querySelectorAll('.mm-bubble').forEach((b) => {
        const t = b.querySelector('.mm-bubble__trigger');
        t.addEventListener('click', (e) => { e.stopPropagation(); const ac = !b.classList.contains('is-open'); b.classList.toggle('is-open', ac); t.setAttribute('aria-expanded', ac ? 'true' : 'false'); });
      });
      document.addEventListener('click', (e) => { this.querySelectorAll('.mm-bubble.is-open').forEach((b) => { if (!b.contains(e.target)) { b.classList.remove('is-open'); b.querySelector('.mm-bubble__trigger').setAttribute('aria-expanded', 'false'); } }); });
    }

    /* ----- Arama ----- */
    aramaKur() {
      if (!this.arama) return;
      this.querySelectorAll('[data-mm-arama-ac]').forEach((b) => b.addEventListener('click', () => { this.aramaAc(true); this.girdi.focus(); }));
      this.querySelectorAll('[data-mm-arama-kapat]').forEach((b) => b.addEventListener('click', () => this.aramaAc(false)));
      this.girdi.addEventListener('focus', () => this.aramaAc(true));
      this.backdrop && this.backdrop.addEventListener('click', () => this.hepsiniKapat());
      this.grid = this.querySelector('[data-mm-sonuc-grid]');
      this.varsayilan = this.grid ? this.grid.innerHTML : '';
      this.baslik = this.querySelector('[data-mm-sonuc-baslik]');
      let t;
      this.girdi.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => this.ara(this.girdi.value.trim()), 250); });
    }
    aramaAc(ac) {
      if (!this.arama) return;
      this.arama.classList.toggle('is-acik', ac);
      this.perde(ac && MD.matches);
      if (!ac && document.activeElement === this.girdi) this.girdi.blur();
    }
    async ara(q) {
      if (!this.grid) return;
      if (q.length < 2) { this.grid.innerHTML = this.varsayilan; this.baslik.textContent = this.baslik.dataset.varsayilan; return; }
      try {
        const kok = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const r = await fetch(`${kok}search?q=${encodeURIComponent(q)}&type=product&section_id=mm-arama-sonuc`);
        const html = await r.text();
        const d = new DOMParser().parseFromString(html, 'text/html');
        const g = d.querySelector('[data-mm-arama-sonuc]');
        this.grid.innerHTML = g ? g.innerHTML : '';
        this.baslik.textContent = this.baslik.dataset.sonuc;
      } catch (e) { /* ağ hatası: varsayılanı koru */ }
    }

    /* ----- Sepet sayacı ----- */
    sepetKur() {
      const s = this.querySelector('[data-mm-sepet-sayi]');
      document.addEventListener('mm:sepet', (e) => {
        const n = e.detail && typeof e.detail.item_count === 'number' ? e.detail.item_count : null;
        if (n === null || !s) return;
        s.querySelector('.mm-count__n').textContent = n; s.classList.toggle('is-hidden', n === 0);
      });
      const kat = this.querySelector('[data-mm-sepet]');
      if (kat) {
        let t;
        kat.addEventListener('mouseenter', () => { if (!XL.matches || !kat.querySelector('.mm-layer')) return; clearTimeout(t); kat.classList.add('is-open'); });
        kat.addEventListener('mouseleave', () => { t = setTimeout(() => kat.classList.remove('is-open'), 200); });
        document.addEventListener('mm:minisepet-ac', () => { if (!MD.matches) return; kat.classList.add('is-open'); clearTimeout(t); t = setTimeout(() => { if (!kat.matches(':hover')) kat.classList.remove('is-open'); }, 3000); });
      }
    }

    /* ----- Favoriler ----- */
    favoriKur() {
      const kat = this.querySelector('[data-mm-favori]'); if (!kat) return;
      const liste = kat.querySelector('[data-mm-favori-liste]'); const bos = kat.querySelector('[data-mm-favori-bos]');
      const ciz = () => {
        const l = favOku();
        bos.hidden = l.length > 0;
        liste.innerHTML = l.slice(0, 4).map((x) => `<li class="mm-favlist__i"><a href="${x.u}"><img src="${x.g || ''}" alt="" width="60" height="80" loading="lazy"><span>${x.t}</span></a></li>`).join('');
      };
      ciz(); document.addEventListener('mm:favori', ciz);
      let t;
      kat.addEventListener('mouseenter', () => { if (!XL.matches) return; clearTimeout(t); kat.classList.add('is-open'); });
      kat.addEventListener('mouseleave', () => { t = setTimeout(() => kat.classList.remove('is-open'), 200); });
    }
  }
  customElements.define('mm-header', MmHeader);
})();
